import { CallPurpose, SequenceStepType } from '../../../../enums';

export const getCallTitle = (purpose: CallPurpose) => {
  if (purpose === CallPurpose.Introduction) {
    return 'Introduction Call';
  }
  if (purpose === CallPurpose.Demo) {
    return 'Demo Call';
  }
  if (purpose === CallPurpose.FollowUp) {
    return 'Follow-up Call';
  }
  if (purpose === CallPurpose.Reminder) {
    return 'Reminder Call';
  }

  return 'Calling Task';
};

export const getSubjectStr = (stepType: SequenceStepType, variantTitle) => {
  if (stepType === SequenceStepType.LinkedInConnectionRequest) {
    return 'LinkedIn Connection Request';
  }
  if (stepType === SequenceStepType.LinkedInMessage) {
    return 'LinkedIn Message';
  }
  if (stepType === SequenceStepType.LinkedInInMail) {
    return 'LinkedIn InMail';
  }
  if (stepType === SequenceStepType.LinkedInViewProfile) {
    return 'LinkedIn View Profile';
  }
  if (stepType === SequenceStepType.LinkedInPostInteraction) {
    return 'LinkedIn Post Interaction';
  }

  if (stepType === SequenceStepType.AimfoxCampaignPush) {
    return 'Push Prospect to Aimfox';
  }

  if (stepType === SequenceStepType.HeyReachCampaignPush) {
    return 'Push Prospect to HeyReach';
  }

  if (stepType === SequenceStepType.WhatsAppMessage) {
    return 'Whatsapp Message';
  }

  if (stepType === SequenceStepType.WhatsAppVoiceMessage) {
    return 'Whatsapp Voice Message';
  }

  if (stepType === SequenceStepType.WhatsAppVoiceCall) {
    return 'Whatsapp Voice Call';
  }

  if (stepType === SequenceStepType.Introduction) {
    return 'Introduction Call';
  }

  if (stepType === SequenceStepType.Demo) {
    return 'Demo Call';
  }

  if (stepType === SequenceStepType.FollowUp) {
    return 'Follow-up Call';
  }

  if (stepType === SequenceStepType.Reminder) {
    return 'Reminder Call';
  }

  if (stepType === SequenceStepType.Other) {
    return 'Calling Task';
  }

  return variantTitle;
};
